export const PartialServiceRebootTipId = 25;
export const PartialServiceCallbackTipId = 26;
export const DeviceFastAsItCanTipId = 41;